import { useQuery } from '@tanstack/react-query'
import { calendarApi } from '@/services/api'

/**
 * Opcions de la query d'unitats d'una propietat, per a `useQuery` i per a `useQueries` (el mode
 * «Totes» del calendari). La clau només porta la propietat: sense `placeholderData`, perquè el
 * «d'abans» seria sempre una altra propietat.
 */
export function calendarUnitsQueryOptions(propertyId: number) {
    return {
        queryKey: ['calendar-units', propertyId] as const,
        queryFn: () => calendarApi.getUnits(propertyId),
        staleTime: 1000 * 60 * 60, // 1 hour (units don't change often)
    }
}

export function useCalendarUnits(propertyId: number) {
    return useQuery(calendarUnitsQueryOptions(propertyId))
}
